import { Avatar, Icon, Stack, Typography } from "components";
import { useClock } from "hooks";
import { User } from "types";
import styles from "./Header.module.css";

interface HeaderProps {
  user?: User;
}

const Header: React.FC<HeaderProps> = ({ user }) => {
  const clock = useClock({ dateStyle: "long", timeStyle: "short" });
  const greeting = user ? `Kamusta ka, ${user.firstName}` : "Kamusta ka";

  return (
    <header className={styles.container}>
      <Stack placeItems="center">
        <Icon name="today" />
        <Typography>Today is {clock}</Typography>
      </Stack>

      <Stack placeItems="center" gap={1.5}>
        <Typography>{greeting}</Typography>
        <Avatar
          src={user?.image}
          alt={user?.firstName[0] || ""}
          size="32px"
          link="/profile"
        />
      </Stack>
    </header>
  );
};

export default Header;
